import { css } from '@emotion/core'
import styled, { Theme } from '@themes/theme'
import { CommonTxtBoxStyle } from '@styles/base.style'
import { messageSenderStyle } from '@views/Popup/Message/index.style'

export const QuickMessageWrap = styled.div`
  display:flex;
  flex-flow: column;
  height: 100%;
  padding-bottom: 20px;
  text-align: left;
  justify-content: space-between;
  .sender-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 60px;
    padding-bottom: 11px;
    color: ${props => props.theme.color.modalgray};
    font-size: ${props => props.theme.font.small};
    border-bottom: 1px solid ${props => props.theme.color.modalBg};
    ${messageSenderStyle};
  }
  .message-contents {
    flex: 1;
    height: auto;
    margin: 17px 0 16px 0;
    line-height: 2rem;
    overflow: auto;
    color: ${props => props.theme.color.modalTxt};
    font-weight: ${props => props.theme.fontW.medium};
    font-size: ${props => props.theme.font.large};
    ${CommonTxtBoxStyle};
    user-select: text; /* auto로 할 경우 PC에서 선택이 안됨 */
    > p { // 에디터로 작성된 경우의 텍스트 스타일을 위해 추가한 코드(주요관리 유저)
      color: ${props => props.theme.color.modalTxt};
      font-size: ${props => props.theme.font.large};
      font-weight: ${props => props.theme.fontW.medium};
      white-space: normal;
      &:last-child {
        padding-bottom: 20px;
      }
    }
    * {
      ${CommonTxtBoxStyle};
      white-space: normal;
      font-weight: ${props => props.theme.fontW.bold};
      font-size: ${props => props.theme.font.large};
      color: revert-layer;
      &:not(strong) {
        font-weight: ${props => props.theme.fontW.medium} !important;    
      }
    }
  }
`
export const messageReadMoreBtnStyle = (theme:Theme) => css`
  width: 100%;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${theme.color.modalSubBg2};
  color: ${theme.color.mainBg};
  font-size: ${theme.font.title};
  font-weight: ${theme.fontW.bold};
`
